import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

export const StyledTabbedDropdownWrapper = styled.div`
    display: flex;
    width: 100%;

    .sdk-category-dd {
        display: flex;
        width: 100%;
    }
`;

export const StyledDropdownButtonContainer = styled.div`
    display: flex;
    & .DropdownButton {
        & .DropdownButton--triangle {
            color: ${colorsPalettes.carbon["400"]};
        }
    }
`;
